"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _dispatcher = _interopRequireDefault(require("dispatcher/dispatcher"));

var _ActionNamespaces = require("crm_data/actions/ActionNamespaces");

var _LazyValueStore = require("crm_data/store/LazyValueStore");

var _PersonaRecord = _interopRequireDefault(require("customer-data-objects/persona/PersonaRecord"));

var _immutable = require("immutable");

var _ImmutableAPI = require("../api/ImmutableAPI");

var _default = (0, _LazyValueStore.defineLazyValueStore)({
  fetch: function fetch() {
    return (0, _ImmutableAPI.get)('contacts/v1/personas', null, function (response) {
      return response.reduce(function (acc, persona) {
        return acc.set(persona.id, _PersonaRecord.default.fromJS(persona));
      }, (0, _immutable.Map)());
    });
  },
  namespace: _ActionNamespaces.PERSONAS
}).defineName('PersonasStore').register(_dispatcher.default);

exports.default = _default;
module.exports = exports.default;